<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h15">PART <span class="th14">ONE</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008.vue?f6ff6de6